import React from 'react';
import { Header, Grid } from 'semantic-ui-react';
import axios from 'axios';
import Notifications from '../Notifications/Notifications';
import StudentServiceHomeStatistic from '../StudentService/StudentServiceHomeStatistic';
import { ToastContainer } from 'react-toastify';
// import StudentServiceHomeStatistic from '../StudentService/StudentServiceHomeStatistic';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;


export default class StudentServiceHome extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div >
                <Header as="h1">Početna</Header>
                <StudentServiceHomeStatistic />
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/views/Home/StudentServiceHome.js